import React from "react";
import PropTypes from "prop-types";
import Wrapper from "../styles/rating-emoji-styles";

const RatingEmoji = ({ rating }) => {
  let emoji;

  switch (rating) {
    case 1:
      emoji = (
        <span
          role="img"
          aria-label="emoji-rating-1"
          className="animated jackInTheBox delay"
        >
          😟
        </span>
      );
      break;
    case 2:
      emoji = (
        <span
          role="img"
          aria-label="emoji-rating-1"
          className="animated jackInTheBox delay"
        >
          😐
        </span>
      );
      break;
    case 3:
      emoji = (
        <span
          role="img"
          aria-label="emoji-rating-1"
          className="animated rollIn delay"
        >
          🙂
        </span>
      );
      break;
    case 4:
      emoji = (
        <span
          role="img"
          aria-label="emoji-rating-1"
          className="animated tada delay"
        >
          😉
        </span>
      );
      break;
    case 5:
      emoji = (
        <span
          role="img"
          aria-label="emoji-rating-1"
          className="animated tada delay"
        >
          🤩
        </span>
      );
      break;
    default:
      emoji = (
        <span
          role="img"
          aria-label="emoji-rating-1"
          className="animatedTwo fadeInDown delay"
        >
          🤔
        </span>
      );
      break;
  }
  return <Wrapper>{emoji}</Wrapper>;
};

RatingEmoji.propTypes = {
  rating: PropTypes.number,
};

RatingEmoji.defaultProps = {
  rating: PropTypes.isNull,
};

export default RatingEmoji;
